import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Filters } from "@air/next-icons";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo } from "react";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
export const FiltersDropdownHeader = /*#__PURE__*/ memo((param)=>{
    let { title } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    const { isAboveMediumScreen } = useBreakpointsContext();
    if (searchImprovements) {
        if (isAboveMediumScreen) {
            return /*#__PURE__*/ _jsx("header", {
                className: "flex h-9 items-center border-b border-b-grey-5 px-3 text-10 font-bold uppercase tracking-wider text-grey-10",
                "data-testid": "FILTERS_DROPDOWN_TITLE",
                children: title
            });
        }
        return /*#__PURE__*/ _jsxs("header", {
            className: "sticky top-0 z-10 flex h-14 items-center gap-2 border-b border-b-grey-4 bg-grey-1 px-4",
            "data-testid": "FILTERS_DROPDOWN_TITLE",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "flex size-10 items-center justify-center",
                    children: /*#__PURE__*/ _jsx(Filters, {
                        className: "size-6 text-grey-10"
                    })
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "text-18 font-medium text-grey-12",
                    children: "Filters"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "FILTERS_DROPDOWN_TITLE",
        className: "border-b border-b-grey-5 p-4 text-12 font-bold uppercase tracking-wider text-grey-10",
        children: title
    });
});
FiltersDropdownHeader.displayName = "FiltersDropdownHeader";
